import { FUNNEL_TARGET_LABELS, GHL_FUNNEL_TARGETS } from '../enums/funnel-stage.enum.js'
import type { GhlFunnelMap } from '../dto/gohighlevel.dto.js'

/**
 * Why a funnel mapping can't be saved as it is, without looking at the account:
 * a stage mapped to nothing in particular, which would mean every lead, or to no
 * calendar. Null when it's complete. The API checks the names against the
 * account as well. See docs/funnel-stages.spec.md.
 */
export function funnelMapIncomplete(map: Pick<GhlFunnelMap, 'stages'>): string | null {
  for (const target of GHL_FUNNEL_TARGETS) {
    const source = map.stages[target]
    if (source === undefined) continue
    const label = FUNNEL_TARGET_LABELS[target]
    // Lost is a state a lead is in, and leaves when it's reopened; a calendar has no way back.
    if (target === 'lost' && source.kind === 'appointments') return 'Lost comes from lead stages, results and tags, not calendars.'
    if (source.kind === 'appointments' && source.definition.calendars.length === 0) {
      return `Choose a calendar for ${label}.`
    }
    if (source.kind === 'leads') {
      const d = source.definition
      if (d.stages.length + d.results.length + d.tagsAny.length + d.tagsNone.length + d.sources.length === 0) {
        return `Choose at least one stage, result, tag or source for ${label}.`
      }
    }
  }
  return null
}
